<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Licitação"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <licitacao-form
            operacaoProp="A"
            :convenio="convenio"
            :licitacao="licitacao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
            @excluirEmpresa="excluirEmpresa($event)"
        ></licitacao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import LicitacaoForm from './LicitacaoForm.vue'

export default {
    components: {
        LicitacaoForm
    },

    props: {
        convenio: Object,
        licitacao: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
        excluirEmpresa(outraEmpresa) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirEmpresaLicitacao(outraEmpresa.idEmpresaLicitacao).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'CNPJ excluído com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvar(licitacao) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.alterarLicitacao(licitacao).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Licitação atualizada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
